const API_URL = process.env.REACT_APP_API_URL

const CONFIG = {
  BASE_URL: API_URL,
}

export default CONFIG;